import ConversionFunnelAPI from '../../api/reports/conversionFunnel';

export const state = {
  summary: null,
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getSummary: $state => $state.summary,
  uiFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetchSummary({ commit }, params) {
    commit('SET_UI_FLAGS', { isFetching: true });
    try {
      const { data } = await ConversionFunnelAPI.getSummary(params);
      commit('SET_SUMMARY', data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('ConversionFunnel: error fetching summary', error);
    } finally {
      commit('SET_UI_FLAGS', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_SUMMARY($state, data) {
    $state.summary = data;
  },
  SET_UI_FLAGS($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
